export default __webpack_public_path__ + "static/jaeyoung.hwang-b5a8036798892e8ef955cd763e2e30f5.jpeg";